


    let lang = window.fxgeoip.code.toLowerCase();

    let broker = window._broker;

    lang = lang === 'in' || lang === 'ie' ? 'en' :  lang;

     lang = lang === 'gr'  ? 'el' :  lang;
     lang = lang === 'sa'  ? 'ar' :  lang;
    
    let folders = {'en':16, 'en_sa':16, 'es':41, 'ar':25, 'hi':67, 'cn':120, 'tw':16, 'cz': 167, 'hu': 92, 'en_uk':92, 'th': 65, 'ko': 182, 'ru':74, 'kz':74, 'en_eu':16, 'hu_eu':92, 'cz_eu':167, 'de':80, 'nl':72, 'el':118, 'fr':78, 'it':70, 'pl':106, 'es':98};



    let exclude_tab =  lang == 'zh' ? [1,7,8,9] : broker == 1 && (lang == 'ar') ? [6,8] : [8,9];

    let tabs;
    switch (lang) {
        case 'en': 
            tabs = ['Most Popular','Top Movers','Currencies','Commodities','Indices','Shares','ETFs','Crypto'];
            break;
        case 'nl': 
            tabs = ['Meest populair', 'Grootste verschuivingen', 'Valuta'+"'"+'s', 'Grondstoffen', 'Indexen', 'Aandelen', 'ETFs', 'Cryptovaluta']; 
            break;
         case 'el': 
            tabs = ['Δημοφιλέστερα', 'Τα πιο καυτά προϊόντα',  'Νομίσματα', 'Εμπορεύματα',  'Δείκτες',  'Μετοχές', 'ETFs', 'Crypto']; 
            break;
       
        default:
            tabs = [];
    }

    let deepLink; 

    switch (broker) {
        case '1': deepLink = 'https://trader.iforex.com/';
            break;
   
            break;
    }

    async function loadRates() {

        const script = document.createElement('script');
        document.body.appendChild(script);
        script.async = true;
        script.defer = true;
        script.src = 'https://content.webapi-services.net/web_assets/scripts/live-rates/widget.var.min.js?env='+env;
        script.onload = () => {
            LiveRates.default({
                folder: folders[lang],
                broker: broker,
                frequency: 6000,
                container: 'lr-widget-wrapper',
                activeTab: window.activeTab || 0,
                maxLines: window.max_lines || 8,
                exclude : ['high','low'],
                cssLink: '',
                lang: lang ,
                exclude_tab: window.lr_widget_config.exclude_tab || exclude_tab,
                icons: true,
                tabs_text : window.lr_widget_config.tabs || tabs,
                deepLink : deepLink
            }).then(function () {
                import(/* webpackPreload: true */'./live-rates.css');

                const skeleton = document.getElementById('live-rates-skeleton');
                
                skeleton &&  requestAnimationFrame(()=> skeleton.classList.add('hide'));

                window.lrCBF && window.lrCBF()
            })
        }; 
    
    }

    let env = window.getparam('env') || 'prod';

    let loader = document.getElementById('lr-loader')

    loadRates()
        .then(() => {
            if(loader) {loader.style.display = 'none';} 
        
        
        })
        .catch(err => {
            console.error(err);
        });





